import Component from './component';

Component.defaultProps = {
    layout: 'fill',
    objectFit: 'cover',
    loading: 'lazy',
};
export default Component;